import reducers from "./reducers";

export { default as tabType } from "./types.js";
export { default as tabSelectors } from "./selectors";
export { default as tabActions } from "./actions";

export default reducers;
